export const getNativeAdPanels = (serverContext, isVideo, isDisplay) => {
  if (isVideo || isDisplay) {
    const multiAdFormatAdPanels = {
      advancedPanels: [
        'third-party-measurement',
      ],
    };

    if (isVideo && serverContext.DynamicPermissions.AdvancedURLOptionsForVideo) {
      multiAdFormatAdPanels.advancedPanels.push('advanced-url-options');
    }

    if (isDisplay && serverContext.DynamicPermissions.AdvancedURLOptionsForDisplay) {
      multiAdFormatAdPanels.advancedPanels.push('advanced-url-options');
    }

    if (serverContext.Permissions.isImpressionTrackingForDisplayAndVideoEnabled) {
      multiAdFormatAdPanels.advancedPanels.push('impression-tracking-URLs');
    }

    return multiAdFormatAdPanels;
  }

  const panels = {
    basicPanels: [
      'images',
      'business-name',
      'text',
    ],
    advancedPanels: [
      'mobile-final-url',
      'advanced-url-options',
      'impression-tracking-URLs',
      'third-party-measurement',
      'ads-optimization',
    ],
  };

  if (serverContext.DynamicPermissions.VideoAsAnAsset && !serverContext.Permissions.IsAmplifyEnabled) {
    panels.basicPanels.push('videos');
  }

  if (serverContext.Permissions.IsAmplifyEnabled && serverContext.DynamicPermissions.DisplayPlusAmplify) {
    panels.basicPanels.push('logos');
    panels.basicPanels.push('hotspot-panel');
    panels.basicPanels.push('portrait-images');

    panels.advancedPanels.push('anchor-ad');
    panels.advancedPanels.push('call-to-action');
  } else if (serverContext.Permissions.IsMSANLogoAndCTAForMMAEnabled) {
    panels.basicPanels.push('logos', 'call-to-action');
  }

  if (serverContext.Permissions.IsMSANDisclaimerEnabled &&
    !serverContext.Permissions.IsDomesticSimplifiedChineseEnabled) {
    panels.advancedPanels.push('disclaimer');
  }

  return panels;
};
